import {Vue, i18n} from './common'
import store from './store'
import IFrameRouter from "@/domain/iframe/IFrameRouter.vue";
import Icon from "./domain/icon/Icon.vue";
import {getBrowserLanguage, setI18nLanguage} from "@/i18n";


// Global mixin
// ---------------------------------------------------------------------------------------------------------------------
const mixin = {
    computed: {},
    methods: {
        log(...args) {
            if (process.env.NODE_ENV === 'development') {
                if (args.length === 1) {
                    console.log(JSON.parse(JSON.stringify(args[0])))
                } else {
                    if (typeof args[0] === 'string') console.group(args.shift())
                    else console.group('Log')
                    for (let arg of args) {
                        console.log(JSON.parse(JSON.stringify(arg)))
                    }
                    console.groupEnd()
                }
            }
        },
        delay(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        async emitPromised(method, ...params) {
            let listener = this.$listeners[method] || this.$attrs[method] || this[method]
            if (listener) {
                let res = await listener(...params)
                return res === undefined || res
            }
            return false
        },
        getCurrencySymbol(currency) {
            return (0).toLocaleString(undefined, {
                style: 'currency',
                currency: currency,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).replace(/\d/g, '').trim();
        }
    }
}
Vue.mixin(mixin)

const currentLanguage = getBrowserLanguage()
const currenciesWithSameSymbol = {
    '$': ['USD', 'CAD', 'AUD', 'NZD', 'SGD', 'HKD', 'MXN', 'XCD'], // Dollar sign
    '¥': ['JPY', 'CNY'],                                           // Yen/Yuan
    '£': ['GBP', 'EGP', 'SYP', 'SDG'],                            // Pound
    'Rs': ['PKR', 'LKR', 'NPR'],                                  // Rupee
    '₣': ['CHF', 'XOF', 'XAF'],                                   // Franc
    '﷼': ['IRR', 'OMR', 'QAR', 'YER'],                            // Riyal/Rial
    'kr': ['SEK', 'NOK', 'DKK', 'ISK'],                           // Krona/Krone
    '₡': ['CRC', 'SVC']                                           // Colon
}

// Convert to an array of objects
const currencyList = Object.entries(currenciesWithSameSymbol).map(([symbol, currencies]) => ({
    symbol,
    currencies
}))

Vue.filter('formatCurrency', function (value, currency) {
    return new Intl.NumberFormat(currentLanguage, {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 2,
        currencyDisplay: currencyList.find(c => c.currencies.includes(currency)) ? 'code' : 'symbol'
    }).format(value)
})



Vue.component('Icon', Icon);

const vueApp = new Vue({
    store,
    i18n,
    data: {
        data: {},
        route: {}
    },
    render: function(createElement) {
        return createElement(IFrameRouter, {
            props: {
                data: this.data,
                route: this.route
            }
        })
    }
}).$mount('#app')
window.vueApp = vueApp  // Added to have access to bvModal in JS files like router.js


window.addEventListener(
    "message",
    (event) => {
        if (!event.data.data || !event.data.route) return
        if (event.data.data.lang) {
            setI18nLanguage(event.data.data.lang)
        }
        vueApp.data = event.data.data
        vueApp.route = event.data.route
    }, false,
);

